import Image from 'next/image'

import { RequestTypeAlias } from '@/api/models/requests/lib/requests.types'
import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { AppButton } from '@/components/shared/button'
import { useRequestNavigation } from '@/components/widgets/request/hooks/useRequestNavigation'

export const RentParkingPlug = () => {
  const { navigateToCreateFormPass } = useRequestNavigation()
  const { breakpoint } = useCurrentBreakpoint()

  const isMobileScreen = [ScreenSize.Xxs, ScreenSize.Xs].includes(breakpoint)

  const handleRedirectToCreatePass = () => {
    navigateToCreateFormPass(RequestTypeAlias.RentPassAuto)
  }

  return (
    <div className="mb-20 flex h-full w-full flex-col items-center text-center">
      <div className="flex flex-1 flex-col items-center justify-center gap-20">
        <Image
          src="/images/passes/Parking.png"
          width={isMobileScreen ? 90 : 180}
          height={isMobileScreen ? 90 : 180}
          alt="parking-image"
        />

        <p className="max-w-[400px] text-grey-60 text-20 lg:text-20 xxs:text-16">
          Пропуск для транспорта оформляется только при наличии машино-места или
          бесплатного гостевого паркинга. Вы можете арендовать место на платном
          паркинге.
        </p>
      </div>

      <AppButton
        className="w-full"
        variant="secondary"
        size="large"
        fluid
        onClick={handleRedirectToCreatePass}
      >
        Арендовать паркинг
      </AppButton>
    </div>
  )
}
